import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=c32a6158&scoped=true&"
import script from "./NavigationFooter.vue?vue&type=script&lang=js&"
export * from "./NavigationFooter.vue?vue&type=script&lang=js&"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&id=c32a6158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32a6158",
  null
  
)

export default component.exports